module.exports = __webpack_public_path__ + "static/media/1 0 Orddiktat Intro.afbd2f39.mp3";